<div
  [title]="title()"
  class="flex gap-1 justify-center items-center text-center text-[12px] text-[#C93535] leading-[16px]">
  <mat-icon class="!w-[14px] !h-[14px]" svgIcon="error"></mat-icon>
  <span class="text-ellipsis overflow-hidden"><ng-content></ng-content></span>
</div>
